module.exports = __webpack_public_path__ + "shanz/static/media/placeholderC.f5d27386.gif";